import React from 'react'

import { ErrorIcon, textPalette, fonts } from '@masfront/common-b2c'

import {
  Modal,
  Backdrop,
  Card,
  Box,
  Typography,
  Divider,
  makeStyles,
  Button,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { Skeleton } from '@material-ui/lab'

import useLegalTexts from './useLegalTexts'

import { LegalTextProps } from '../../model/legal.model'

const useStyles = makeStyles(() => ({
  modal: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  card: {
    width: '936px',
  },
  icon: {
    cursor: 'pointer',
  },
}))

function LegalTextsError({ retryLegalTexts }: { retryLegalTexts: () => void }) {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column">
      <Box mb={6}>
        <ErrorIcon />
      </Box>
      <Box mb={6}>
        <Typography variant="h2" data-hook="legal-error-title">
          Ha sucedido un error inesperado.
        </Typography>
      </Box>
      <Box mb={20}>
        <Typography variant="body1" color="textSecondary">
          No se han podido recuperar los textos legales, por favor inténtalo de nuevo.
        </Typography>
      </Box>
      <Box mr={6}>
        <Button
          variant="contained"
          color="secondary"
          size="medium"
          onClick={retryLegalTexts}
          data-hook="retry-legal"
        >
          Reintentar
        </Button>
      </Box>
    </Box>
  )
}

export default function LegalTexts({ isOpen, onConfirm, onClose }: LegalTextProps) {
  const { card, modal, icon } = useStyles()
  const { legalTexts, isLoading, legalTextsError, retryLegalTexts } = useLegalTexts()

  const skeleton = [100, 80, 100, 80, 70]

  const modalBody = legalTextsError ? (
    <LegalTextsError retryLegalTexts={retryLegalTexts} />
  ) : (
    <Box
      // eslint-disable-next-line react/no-array-index-key
      fontSize={fonts.size.base}
      color={textPalette.secondary}
      fontFamily={fonts.primary}
      lineHeight="1.5"
      dangerouslySetInnerHTML={{ __html: legalTexts.text }}
    />
  )

  return (
    <Modal
      open={isOpen}
      BackdropComponent={Backdrop}
      className={modal}
      disableAutoFocus
      disableEnforceFocus
    >
      <Box component={Card} borderRadius="14px" className={card} p={8}>
        <Box display="flex" flexDirection="row" justifyContent="space-between">
          <Box>
            <Typography variant="h2" data-hook="legal-title">
              Textos de confirmación
            </Typography>
          </Box>
          <Box>
            <CloseIcon data-hook="close-legal" onClick={onClose} className={icon} />
          </Box>
        </Box>
        <Box py={5}>
          <Divider />
        </Box>
        {isLoading !== false
          ? skeleton.map((elem, i) => (
              <Skeleton
                component="p"
                // eslint-disable-next-line react/no-array-index-key
                key={`skeleton-${i}`}
                variant="text"
                height={elem}
                width="100%"
              />
            ))
          : modalBody}
        {isLoading === false && !legalTextsError && (
          <Box pt={7}>
            <Button
              variant="contained"
              color="secondary"
              onClick={onConfirm}
              data-hook="confirm-legal"
            >
              Confirmar
            </Button>
          </Box>
        )}
      </Box>
    </Modal>
  )
}
